import {useNewProduct} from "../../../store/contexts/NewProductContext";
import axios from "axios";
import {useEffect, useState} from "react";
import {TYPES} from "../../../store/reducers/NewProductReducer";


const ManufacturerCard = () => {
    const { product, dispatch, errors, data } = useNewProduct();

    return (
        <div className="card card-flush py-4">
            <div className="card-header">
                <div className="card-title">
                    <h2>Brands</h2>
                </div>
            </div>

            <div className="card-body pt-0">
                <div className="fv-row mb-2">
                    <div className="fv-row">
                        <label className="required form-label">Brand Name</label>
                        <select className="form-select" aria-label="Select example"
                                onChange={event => dispatch({
                                    type: TYPES.SET_PRODUCT,
                                    payload: {...product, brand_id: parseInt(event.target.value)}
                                })}
                                value={product.brand_id || ''}
                        >
                            <option value="">Choose Brand</option>
                            {
                                data?.brands?.map((brand, index) => (
                                    <option
                                        key={index}
                                        value={brand.id}
                                    >
                                        {brand.name}
                                    </option>
                                ))
                            }

                        </select>
                    </div>
                </div>
                {
                    errors.hasOwnProperty("brand_id") && (
                        <div className="fs-7 mb-7 text-danger">{errors.brand_id}</div>
                    )
                }
            </div>
        </div>
    )
}

export default ManufacturerCard;
